import React, { forwardRef } from 'react';

const Input = forwardRef(({ 
  type = 'text',
  value,
  onChange,
  placeholder,
  disabled = false,
  readOnly = false,
  required = false,
  className = '',
  error = false,
  size = 'md',
  ...props 
}, ref) => {
  const sizeClasses = size === 'sm' ? 'h-7 px-2 py-1 text-xs' : 'h-10 px-3 py-2';
  const baseClasses = `w-full ${sizeClasses} border rounded-md focus:outline-none transition-colors`;
  
  const stateClasses = {
    normal: 'border-gray-300 focus:ring-2 focus:ring-naviter-blue focus:border-transparent',
    error: 'border-red-300 focus:ring-2 focus:ring-red-500 focus:border-transparent',
    disabled: 'bg-gray-50 text-gray-700 cursor-not-allowed border-gray-300',
    readOnly: 'bg-gray-50 text-gray-700 cursor-not-allowed border-gray-300'
  };

  let stateClass;
  if (disabled || readOnly) {
    stateClass = disabled ? stateClasses.disabled : stateClasses.readOnly;
  } else if (error) {
    stateClass = stateClasses.error;
  } else {
    stateClass = stateClasses.normal;
  }

  const classes = `${baseClasses} ${stateClass} ${className}`.trim();

  return (
    <input
      ref={ref}
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      disabled={disabled}
      readOnly={readOnly}
      required={required}
      className={classes}
      {...props}
    />
  );
});

export default Input;
